const buildVersion: string = '$BUILD_VERSION';

function getImagePathForCurrentBuild (imageFileName: string): string {
  return '/static/media/' + imageFileName + '?v=' + buildVersion;
}

// $BUILD_VERSION will be replaced with a unique string by webpack build
export default buildVersion;

export {
  buildVersion,
  getImagePathForCurrentBuild
};
